import './style.sass';

import FullWrapper from 'core/FullWrapper';

const LayoutPage = () => {
    return (
        <div className="moscowExchange-layout-page">
            <FullWrapper className="moscowExchange-layout-pageCase">
                <div className="moscowExchange-layout-pageWrapper">
                    {/* eslint-disable-next-line no-secrets/no-secrets */}
                    <div className="moscowExchange-layout-pageListParagraf">
                        <div className="moscowExchange-layout-pageParagraf">
                            <div className="moscowExchange-layout-pageParagraf">
                                Это два очень крупных сайта со&nbsp;сложной разветвленной структурой
                                и&nbsp;большим количеством продвигаемых страниц и&nbsp;поисковой
                                &laquo;историей&raquo;, которая за&nbsp;счет своей авторитетности
                                привлекает хорошую долю трафика. Этого недостаточно для стабильного
                                роста.
                            </div>
                            <div className="moscowExchange-layout-pageParagraf">
                                В&nbsp;финансовой нише увеличилась доля агрегаторов, которые стянули
                                на&nbsp;себя весь органический трафик. И&nbsp;все сложнее
                                конкурировать с&nbsp;поисковыми системами, которые пытаются удержать
                                пользователей на&nbsp;страницах поиска или в&nbsp;своих сервисах.
                            </div>
                            <div>
                                Наша команда разработала комплексную SEO-стратегию для двух проектов
                                Московской биржи по&nbsp;увеличению трафика и&nbsp;нашла точки роста
                                для каждого сайта.
                            </div>
                        </div>
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default LayoutPage;
